import {calculateDistance} from './geolocation';

export default class DistanceHolder {

  #dom = {};

  constructor(element) {
    this.#dom.element = element;
    this.#dom.distanceSpan = element.querySelector('.distance');
  }

  /**
   * Calculate distance and
   */
  calculateDistance() {
    navigator.geolocation.getCurrentPosition((position) => {

      //Show distance-holder only after location is recieved
      this.#dom.element.classList.remove('hidden');

      const result = this.#dom.element?.dataset?.coords?.split(';');

      if( result ) {
        const [sLat, sLon] = result;
        const distance = calculateDistance( sLat, sLon, position.coords.latitude, position.coords.longitude );
        this.#dom.distanceSpan.innerText = distance;
      }

    }, console.error );
  }

  static init() {
    document.querySelectorAll('.distance-holder').forEach( element => {
      const distanceHolder = new DistanceHolder( element );
      distanceHolder.calculateDistance();
    });
  }
}

